import { Divider, Stack, Typography } from '@mui/material';
import { useFormContext, useWatch } from 'react-hook-form';
import type { PackageFormValues } from '@/views/add-package/add-package.types';
import { getMinPriceFromDualCurrency } from '@/utils/getMinPriceFromDualCurrency';
import { getUniqueProducts } from '../../../PricingStep/heleprs';
import { PreviewSectionCard } from '../PreviewSectionCard';

const DEFAULT_DISCOUNT: PackageFormValues['discount'] = {
    amount: 0,
    type: 'relative',
};

const PricingFinancialSection = () => {
    const { control } = useFormContext<PackageFormValues>();
    const products = useWatch({
        control,
        name: 'products',
        defaultValue: [],
    });
    const discount = useWatch({
        control,
        name: 'discount',
        defaultValue: DEFAULT_DISCOUNT,
    });
    const total = useWatch({
        control,
        name: 'total',
        defaultValue: 0,
    });
    const currency = useWatch({
        control,
        name: 'globalCurrency',
        defaultValue: '',
    });
    const uniqueProducts = getUniqueProducts(products);
    const baseTotal = uniqueProducts.reduce(
        (acc, product) => acc + getMinPriceFromDualCurrency(product.price),
        0
    );

    return (
        <PreviewSectionCard title="Pricing and Financial">
            <Stack spacing={1.5}>
                {uniqueProducts.map(item => (
                    <Stack
                        key={item.id}
                        direction="row"
                        justifyContent="space-between"
                    >
                        <Typography variant="body2" color="text.secondary">
                            {item.name}
                        </Typography>
                        <Typography variant="body1" fontWeight={600}>
                            {getMinPriceFromDualCurrency(item.price)}
                            <small>{currency || ''}</small>
                        </Typography>
                    </Stack>
                ))}
                <Divider />
                <Stack direction="row" justifyContent="space-between">
                    <Typography variant="body2" color="text.secondary">
                        Subtotal
                    </Typography>
                    <Typography variant="body1" fontWeight={600}>
                        {baseTotal}
                        <small>{currency || ''}</small>
                    </Typography>
                </Stack>
                <Stack direction="row" justifyContent="space-between">
                    <Typography variant="body2" color="text.secondary">
                        Discount
                    </Typography>
                    <Typography variant="body1" fontWeight={600}>
                        {discount.amount}{' '}
                        {discount.type === 'relative' ? '%' : currency}
                    </Typography>
                </Stack>
                <Stack direction="row" justifyContent="space-between">
                    <Typography variant="body2" color="text.secondary">
                        Total
                    </Typography>
                    <Typography variant="body1" fontWeight={600}>
                        {total}
                        <small>{currency || ''}</small>
                    </Typography>
                </Stack>
            </Stack>
        </PreviewSectionCard>
    );
};

export default PricingFinancialSection;
